import httpClient from '@/bundles/http-client';
class ApiClient {
    _get(url, config) {
        return httpClient.get(url, config);
    }

    _delete(url, config) {
        return httpClient.deleteCsrf(url, config);
    }

    _post(url, data, config) {
        return httpClient.postCsrf(url, data, config);
    }
}

export default ApiClient;
